import React from 'react';
import { HomeIcon } from '@heroicons/react/20/solid';

import Sidebar from '@components/Sidebar';

const OnboardingDashboard = () => {
	return (
		<Sidebar.Item to="/unify-onboarding">
			<HomeIcon />
			Dashboard
		</Sidebar.Item>
	);
};

export default OnboardingDashboard;
